// Presentation mapping for live astrologer data (@astro/api → card props).
// The old hardcoded ASTROLOGERS array is gone — the section now fetches from
// GET /v1/astrologers?page=1&per_page=4 and decorates each record here.

/** Emoji per skill slug for filter tabs and category badges. */
export const SKILL_EMOJI = {
  'career-counseling': '💼',
  'face-reading': '🀄',
  'gems-stone-guidance': '💎',
  'horoscope-reading': '🔮',
  'kundli-matching': '💍',
  muhurat: '📿',
  'palm-reading': '✋',
  palmistry: '🖐️',
  'perosnal-relationship': '❤️',
  'prashna-kundali': '📜',
  'vastu-shastra': '🏡',
  'vedic-astrology': 'ॐ',
}

export const skillEmoji = (slugOrName) => {
  const slug = String(slugOrName).toLowerCase().replace(/[^a-z0-9]+/g, '-')
  return SKILL_EMOJI[slug] ?? '✦'
}

/** Photo-fallback gradients, cycled by list position. */
const FALLBACK_GRADIENTS = [
  'linear-gradient(160deg,#FDE68A 0%,#F59E0B 50%,#D97706 100%)',
  'linear-gradient(160deg,#FDE8D8 0%,#F4A261 50%,#E76F51 100%)',
  'linear-gradient(160deg,#FEF3C7 0%,#FBBF24 50%,#D97706 100%)',
  'linear-gradient(160deg,#EDE9FE 0%,#A78BFA 50%,#7C3AED 100%)',
]

const CATEGORY_TAG_STYLE = {
  background: 'rgba(254,243,199,.9)',
  color: '#92400E',
  border: '1px solid rgba(146,64,14,.18)',
}

const formatPrice = (rate) => {
  const value = Number(rate)
  if (!Number.isFinite(value) || value <= 0) return 'Free'
  return `₹${value.toLocaleString('en-IN')}`
}

/** Shape a live API record into the props AstrologerCard renders. */
export function decorateAstrologer(record, index) {
  const name = record.display_name || record.name
  const rating = Number(record.rating ?? 0)
  // The plain /astrologers listing has no online_status — treat as available.
  const online = record.online_status ? record.online_status === 'online' : true
  const primarySkill = record.skills?.[0]

  return {
    id: record.id,
    name,
    role: primarySkill ?? 'Vedic Astrologer',
    /** Primary skill drives the filter tabs. */
    category: primarySkill ?? 'Vedic Astrology',
    /** Search haystack: name + every skill and language. */
    spec: [name, record.name, ...(record.skills ?? []), ...(record.languages ?? [])]
      .join(' ')
      .toLowerCase(),
    image: record.image_url,
    fallbackGradient: FALLBACK_GRADIENTS[index % FALLBACK_GRADIENTS.length],
    fallbackLetter: (name || 'A').charAt(0).toUpperCase(),
    featured: rating >= 4.5,
    status: online ? 'live' : 'busy',
    tag: primarySkill ? `${skillEmoji(primarySkill)} ${primarySkill}` : '✦ Astrology',
    tagColor: CATEGORY_TAG_STYLE,
    exp: `${record.experience} Yr${record.experience === 1 ? '' : 's'}`,
    duration: `${record.duration} Min`,
    rating,
    reviews: record.reviews_count ?? 0,
    languages: record.languages ?? [],
    price: formatPrice(record.rate),
    cta: online ? 'Book Now' : 'Notify Me',
  }
}
